import { baseSchema, Update } from '../base'
import { generate } from '../generate'
import { z } from 'zod'

const statuses = z.enum(['created', 'modified', 'deleted'])
export const blockMilestoneSchema = baseSchema.extend({
  createdAt: z.string(),
  updatedAt: z.string().optional(),
  branchId: z.string(),
  rootId: z.string(),
  blockId: z.string(),
  commitId: z.string().nullish(), // if defined means immutable
  parentId: z.string().nullish(), // used to open new commit tab
  sourceBlockId: z.string(),
  contributors: z.record(statuses, z.array(z.string()).nullish()),
  currentStatus: statuses,
  /** Milestone IDs */
  dependencies: z.array(z.string()),
  reordered: z
    .object({
      from: z.string(),
      to: z.string(),
    })
    .nullish(),
})

export type BlockMilestone = z.infer<typeof blockMilestoneSchema>
export type BlockMilestoneUpdate = Update<BlockMilestone>

export const blockMilestoneBaseOps = generate(
  'milestone',
  blockMilestoneSchema.parse
)
